import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface HomePreferencesIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const HomePreferencesIcon = ({
  color = RoutalPalette.white,
  style = {},
  ...props
}: HomePreferencesIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ width: `24px`, height: `24px`, ...style }}>
      <g>
        <rect y="3.75" width="24" height="1.5" rx="0.75" fill={color} />
        <rect y="11.25" width="24" height="1.5" rx="0.75" fill={color} />
        <rect y="18.75" width="12" height="1.5" rx="0.75" fill={color} />
      </g>
    </SvgIcon>
  );
};
